import React from 'react';
import RayPagination from '../common/RayPagination';
import { Translate as t } from '../../config/Translate';

export const PAGE_SIZE_OPTIONS = [10, 30, 50, 100];

// 표 아래 한 줄: 표시 개수 select + 쪽 넘김 + 총 건수. 표시 개수 라벨에 맞는 기존 lang 키가 없어
// 라벨 없이 숫자 select 만 둔다(aria-label 은 기존 common.button.show). 총 건수는 기존 common.label.total.
// .table-pager (common.css) 는 RayPagination ul 의 위아래 여백만 이 안에서 제거한다.
const TablePager = ({ total, page, pageSize, onPageChange, onPageSizeChange }) => {
    const count = Number(total) || 0;
    if (count <= 0) return null;

    return (
        <div className="table-pager d-flex flex-wrap align-items-center gap-2">
            <select
                className="form-select form-select-sm w-auto"
                aria-label={t('common.button.show')}
                value={pageSize}
                onChange={(e) => onPageSizeChange && onPageSizeChange(parseInt(e.target.value, 10))}
            >
                {PAGE_SIZE_OPTIONS.map((n) => (
                    <option key={n} value={n}>{n}</option>
                ))}
            </select>
            {/* RayPagination 은 pageSize 를 내부 state 에 한 번만 고정하므로 key 로 재마운트 */}
            <RayPagination
                key={pageSize}
                totalItems={count}
                curPage={page}
                pageSize={pageSize}
                paginate={(pg) => onPageChange && onPageChange(pg)}
            />
            <span className="small text-muted ms-auto">{t('common.label.total')} {count}</span>
        </div>
    );
};

export default TablePager;
